'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import { UrlObject } from 'url';
import { Teacher, teachers as teachersData } from '@/db/teachersData';

interface OurTeachersProps {
    teachers?: Teacher[];
    itemsPerPage?: number;
}

const OurTeachers: React.FC<OurTeachersProps> = ({
    teachers = teachersData,
    itemsPerPage = 12,
}) => {
    const [currentPage, setCurrentPage] = useState(1);

    // Calculate pagination
    const totalPages = Math.ceil(teachers.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentTeachers = teachers.slice(startIndex, endIndex);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            handlePageChange(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            handlePageChange(currentPage + 1);
        }
    };

    return (
        <section className="teachers-area">
            <div className="container">
                <div className="row">
                    {currentTeachers.map((teacher: { id: React.Key | null | undefined; image: string | StaticImport; name: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; role: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; facebook?: string | undefined; twitter?: string | undefined; email?: string | undefined; }) => (
                        <div key={teacher.id} className="col-lg-3 col-sm-6">
                            <div className="single-teacher">
                                {/* Teacher Image */}
                                <div className="teacher-img">
                                    <Link href={`/teacher?id=${teacher.id}`}>

                                        <Image
                                            src={teacher.image}
                                            alt={String(teacher.name) || 'Teacher'}
                                            width={250}
                                            height={250}
                                            quality={85}
                                        />
                                    </Link>
                                </div>

                                {/* Teacher Content */}
                                <div className="teachers-content">
                                    <h2>{teacher.name}</h2>
                                    <p>{teacher.role}</p>
                                </div>

                                {/* Social Links */}
                                {/* <div className="teacher-social">
                                    <ul>
                                        {teacher.facebook && (
                                            <li>
                                                <a
                                                    href={teacher.facebook}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    aria-label={`${teacher.name} Facebook profile`}
                                                >
                                                    <i className="fa-brands fa-facebook"></i>
                                                </a>
                                            </li>
                                        )}
                                        {teacher.twitter && (
                                            <li>
                                                <a
                                                    href={teacher.twitter}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    aria-label={`${teacher.name} Twitter profile`}
                                                >
                                                    <i className="fa-brands fa-twitter"></i>
                                                </a>
                                            </li>
                                        )}
                                        {teacher.email && (
                                            <li>
                                                <Link href={teacher.email} aria-label="Contact">
                                                    <i className="fa-regular fa-envelope"></i>
                                                </Link>
                                            </li>
                                        )}
                                        <li>
                                            <Link
                                                href={`/teacher?id=${teacher.id}`}
                                                aria-label={`View ${teacher.name} profile`}
                                            >
                                                <i className="fa-solid fa-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <ul className="pagination">
                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={handlePreviousPage}
                                    disabled={currentPage === 1}
                                    aria-label="Previous page"
                                    type="button"
                                >
                                    <i className="fa-solid fa-angle-left"></i>
                                </button>
                            </li>

                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                                (page) => (
                                    <li
                                        key={page}
                                        className={`page-item ${page === currentPage ? 'active' : ''}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(page)}
                                            aria-label={`Go to page ${page}`}
                                            aria-current={page === currentPage ? 'page' : undefined}
                                            type="button"
                                        >
                                            {page}
                                        </button>
                                    </li>
                                )
                            )}

                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={handleNextPage}
                                    disabled={currentPage === totalPages}
                                    aria-label="Next page"
                                    type="button"
                                >
                                    <i className="fa-solid fa-angle-right"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};


export default OurTeachers;
